import { render, staticRenderFns } from "./SkillCompetition.vue?vue&type=template&id=d9660dca"
import script from "./SkillCompetition.vue?vue&type=script&lang=js"
export * from "./SkillCompetition.vue?vue&type=script&lang=js"
import style0 from "./SkillCompetition.vue?vue&type=style&index=0&id=d9660dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports